import { t } from '@lingui/core/macro';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SidebarMenuCollapsible } from 'app/domains/common-ui';
import { useListDashboards } from './useListDashboards';
import { useDesktopNavigation } from '../../../DesktopNavigation';
import { CollapsibleItemLink } from '../CollapsibleItemLink';
import { ItemLink } from '../ItemLink';
import { useLinkMatch } from '../useLinkMatch';
export function CollapsibleInsights() {
    const { collapsibleStates, toggleCollapsible } = useDesktopNavigation();
    const { data, loading } = useListDashboards();
    const activeChild = useLinkMatch({
        matchPath: ['/insights'],
        matchExact: false,
    });
    if (loading) {
        return null;
    }
    if (!data.length) {
        return (<ItemLink to="/insights" icon={<Falcon icon="chart-simple"/>} label={t({ comment: 'Sidebar menu - Insights label', message: 'Insights', context: 'sidebar' })} matchPath={['/insights']}/>);
    }
    return (<SidebarMenuCollapsible icon={<Falcon icon="chart-simple"/>} label={t({ comment: 'Sidebar menu - Insights label', message: 'Insights', context: 'sidebar' })} activeChild={activeChild} collapsibleKey="insights" open={collapsibleStates.insights} onToggle={toggleCollapsible}>
      {data.map((dashboard) => (<CollapsibleItemLink key={dashboard.id} to={`/insights/${dashboard.id}`} label={dashboard.label} matchPath={`/insights/${dashboard.id}`}/>))}
    </SidebarMenuCollapsible>);
}
